import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { ScrollElement } from '@/components/functional/Scroll/ScrollElement/ScrollElement';
import { LinkButton } from '@/components/ui/Button/LinkButton';
import { PREV_PATH_CONTEXT_LOCATION_STATE_KEY } from '@/context/PrevPathContext';
import { HotlineDescriptionList, } from '@/feature/hotline/component/HotlineDescriptionList';
import { HOTLINE_UN_DISCLOSE } from '@/feature/hotline/constant/disclose';
import { hotlineProfessionalText } from '@/feature/hotline/professional/constant/text';
import { HotlineProDetailTab, HOTLINE_PRO_DETAIL_TAB_VALUE_DETAIL, } from '@/feature/hotline/professional/detail/component/HotlineProDetailTab';
import { HotlineProDetailViewLayout } from '@/feature/hotline/professional/detail/component/HotlineProDetailViewLayout';
import { hotlineProDetailViewStyle } from '@/feature/hotline/professional/detail/index/page/style';
import { isFirstRepliedDetailData } from '@/feature/hotline/professional/detail/util/typeGuard';
import { formatDateToRangeText, formatDateToText, } from '@/feature/hotline/util/formatDate';
import { scrollToWithHeaderHeight } from '@/helpers/ScrollUtils';
import { useLocation } from '@/hooks/lib/react-router/useLocation';
import { pagePath } from '@/utils/router/pagePath';
/** 内容表示部分のスクロール name */
export const HOTLINE_PRO_DETAIL_INDEX_SCROLL_CONTENT = 'scroll_content';
/**
 * 匿名ホットライン コンサル詳細 詳細内容ページ（View 部分のみ）
 * @description View 全体の表示, api 取得データを表示用に変換して渡す
 */
export const HotlineProDetailView = (props) => {
    const { detailData } = props;
    const { hash } = useLocation();
    /** 初回返信前 */
    const isFirstReplied = isFirstRepliedDetailData(detailData);
    /** 募集終了か */
    const isClosed = detailData.is_request_deadline_expired || detailData.is_paused;
    // ハッシュがある場合はスクロール
    useEffect(() => {
        if (hash) {
            scrollToWithHeaderHeight(hash.replace('#', ''));
        }
    }, [hash]);
    /** 表示する詳細内容 */
    const descriptionItems = useMemo(() => {
        const items = [
            {
                head: '相談タイトル',
                value: detailData.title,
            },
            {
                head: '企業名',
                value: detailData.disclose === HOTLINE_UN_DISCLOSE.value
                    ? '匿名'
                    : detailData.client_organization_name || '-',
            },
            {
                head: '業界',
                value: detailData.industry,
            },
            {
                head: '企業規模',
                value: detailData.client_organization_sales,
            },
            {
                head: '相談の背景',
                value: detailData.description,
            },
            {
                head: '期待するアドバイス',
                value: detailData.advice_request,
            },
            {
                head: '相談希望日',
                value: formatDateToRangeText(detailData.interview_requested_from_at, detailData.interview_requested_to_at),
            },
        ];
        const deadlineItem = {
            head: '回答期限',
            value: detailData.is_paused
                ? 'クライアントにより募集終了'
                : formatDateToText(detailData.request_deadline_at),
        };
        return isFirstReplied ? items : [...items, deadlineItem];
    }, [detailData, isFirstReplied]);
    const style = hotlineProDetailViewStyle({ showTab: isFirstReplied });
    return (_jsxs(HotlineProDetailViewLayout, Object.assign({ detailData: detailData }, { children: [isFirstReplied && (_jsx(HotlineProDetailTab, { activeValue: HOTLINE_PRO_DETAIL_TAB_VALUE_DETAIL, id: detailData.id, isSkeleton: false, unreadCount: detailData.hotline_request.unread_count })), _jsx(ScrollElement, Object.assign({ name: HOTLINE_PRO_DETAIL_INDEX_SCROLL_CONTENT }, { children: _jsxs("div", Object.assign({ className: style.content() }, { children: [!isFirstReplied && _jsx("h2", Object.assign({ className: style.title() }, { children: "\u76F8\u8AC7\u8A73\u7D30" })), _jsx(HotlineDescriptionList, { items: descriptionItems }), !isClosed && !isFirstReplied && (_jsx(LinkButton, Object.assign({ className: style.button(), color: 'orange', routerLinkAttributes: {
                                state: {
                                    [PREV_PATH_CONTEXT_LOCATION_STATE_KEY]: pagePath.hotline.professional.detail(detailData.id),
                                },
                            }, size: 'md', to: pagePath.hotline.professional.firstReplyInput(detailData.id) }, { children: hotlineProfessionalText.action.sendOffer() })))] })) }))] })));
};
